import React from 'react';
import Select from 'components/Select';
import Button from 'components/Button';
import StaplesOrderTypeModal from 'pages/staples-bulk-orders/StaplesOrderTypeModal';
import {
  Header as StyledHeader,
  Title,
  UploadPdfForm,
} from 'styles/pages/staples-bulk-orders';

export const openCloudinaryWidget = (folder, clientAllowedFormats, cb) => {
  const myWidget = window.cloudinary.createUploadWidget(
    {
      cloudName: 'big-oven-tees-inc',
      uploadPreset: 'tnedst8q',
      folder,
      clientAllowedFormats,
    },
    (error, result) => {
      if (!error && result && result.event === 'success') {
        cb({
          secureUrl: result?.info?.secure_url,
          publicId: result?.info?.public_id,
        });
        myWidget.close();
      }
    }
  );
  myWidget.open();
};

const Header = ({ state, setState }) => (
  <StyledHeader>
    <Title>Staples Order Submission</Title>
    <UploadPdfForm>
      <Select
        label="Select Print Provider"
        options={['CA']}
        value={state?.printProvider}
        onChange={(printProvider) =>
          setState({
            ...state,
            printProvider,
          })
        }
      />

      <Button
        title="Upload Staples PO (.pdf)"
        onClick={() =>
          setState({
            ...state,
            staplesOrderTypeModal: true,
          })
        }
      />

      <Button
        title="Saved Orders"
        onClick={() =>
          setState({
            ...state,
            submittedOrdersModal: true,
          })
        }
      />
    </UploadPdfForm>

    <StaplesOrderTypeModal
      state={state}
      setState={setState}
      uploadPO={() => {
        openCloudinaryWidget(`BOTApp/StaplesPO/OrdersDoc`, ['pdf'], (r) =>
          setState({
            ...state,
            poPdfPath: r?.secureUrl,
            poPdfPublicId: r?.publicId,
            staplesOrderTypeModal: false,
          })
        );
      }}
    />
  </StyledHeader>
);

export default Header;
